import { j as p } from "../../jsx-runtime-B6kdoens.js";
import { a as l } from "../../index-CROKJrb5.js";
import { c as x, f as A } from "../../create-component-CBAeEoQ6.js";
import { u as o } from "../../use-sync-atom-value-CDr7vapO.js";
import { createListState as d, ListContext as L, useListStateAtoms as w } from "./ListState/index.js";
import { w as j } from "../../atom-provider-B3P183Tj.js";
import { u as C } from "../../use-unique-id-BA9hSqap.js";
const y = j(
  x(
    "List",
    A(
      ({ as: r, children: s, className: e, id: t, size: m, ...i }, a) => {
        const c = r || "ul", u = C("list", t), { idAtom: f, sizeAtom: n } = w();
        return o(f, t), o(n, m), /* @__PURE__ */ p.jsx(
          c,
          {
            ref: a,
            className: l(
              "cur-flex cur-w-full cur-flex-col cur-gap-2 cur-p-0",
              e
            ),
            id: u,
            ...i,
            children: s
          }
        );
      }
    )
  ),
  L,
  d
);
export {
  y as List
};
//# sourceMappingURL=index.js.map
